<template>
  <div>
    <Head :title="__(title)" />
    <div class="bg-white rounded-md shadow overflow-hidden w-full">
      <form @submit.prevent="update">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.sn" :error="form.errors.sn" class="pr-6 pb-8 w-full" :label="__('Serial Number')" />

          <select-input v-model="form.type_assets_id" @change="updateCategoryAndBrand" :error="form.errors.type_assets_id" class="pr-6 pb-8 w-full lg:w-1/3" :label="__('Type')" :required="true">
            <option :value="null">{{ __('Select Type') }}</option>
            <option v-for="s in type" :key="s.id" :value="s.id">{{ `${s.name} - ${s.category} - ${s.brand}` }}</option>
          </select-input>

          <text-input v-model="form.category" :error="form.errors.category" class="pr-6 pb-8 w-full lg:w-1/3" :label="__('Category')" disabled />

          <text-input v-model="form.brand" :error="form.errors.brand" class="pr-6 pb-8 w-full lg:w-1/3" :label="__('Brand')" disabled />
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <button class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Delete</button>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">{{ __('Update') }}</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import { Head } from '@inertiajs/vue3'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import SelectInput from '@/Shared/SelectInput'

export default {
  metaInfo() {
    return { title: this.form.sn }
  },
  components: {
    LoadingButton,
    TextInput,
    SelectInput,
    Head,
  },
  layout: Layout,
  props: {
    title: String,
    type: Array,
    serial_number: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        sn: this.serial_number.sn,
        type_assets_id: this.serial_number.type_assets_id,
        category: this.serial_number.category || '',
        brand: this.serial_number.brand || '',
      }),
    }
  },
  methods: {
    updateCategoryAndBrand() {
      const selectedType = this.type.find((t) => t.id === this.form.type_assets_id)
      if (selectedType) {
        this.form.category = selectedType.category || ''
        this.form.brand = selectedType.brand || ''
      } else {
        this.form.category = ''
        this.form.brand = ''
      }
    },
    update() {
      this.form.put(this.route('asset_serial_number.update', this.serial_number.id))
    },
    destroy() {
      if (confirm('Are you sure you want to delete this data?')) {
        this.$inertia.delete(this.route('asset_serial_number.destroy', this.serial_number.id))
      }
    },
  },
}
</script>
